require('shared/polyfills/intl');

import ReactDOM from 'react-dom';
import React from 'react';
import {Provider} from 'react-redux';

import loadInitialState from 'sport-betting/loadInitialState';
import configureStore from 'sport-betting/Store';

import rootSaga from 'sport-betting/rootSaga';

import LocaleProvider from 'sport-betting/components/LocaleProvider';

import routes from 'sport-betting/routes';

const initialState = loadInitialState();

const store = configureStore(initialState);

store.runSaga(rootSaga);

ReactDOM.render(
    <Provider store={store}>
        <LocaleProvider>
            {routes(store)}
        </LocaleProvider>
    </Provider>,
    document.getElementById('app')
);



// WEBPACK FOOTER //
// ./js/apps/sport-betting.js